module.exports = __webpack_public_path__ + "static/media/css3.ae3a5956.png";